import React, { useState, useEffect } from "react";
import { useNavigate , useLocation} from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../../Apis/request";
import { BaseURL, Role, uniqueToken, GpsBaseURL } from "../../../api/DataApis";
import axios from "axios";
import { useParams } from "react-router-dom";
import Select from 'react-select';

function Edit(props) {
  document.title = "Category List | Edit";
  let navigate = useNavigate();
   let location = useLocation();
    let FilterCategoryEditData = location?.state?.FilterCategoryEditData;
    const sluggg = FilterCategoryEditData?.slug;
    console.log("FilterCategoryEditData", FilterCategoryEditData);
    let params = useParams();
    let CategoryID = params?.cid;

    console.log("categoryID", CategoryID);

    console.log("sluggg", sluggg);

  const [TitleName, setTitleName] = useState([]);
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [Imageurl, setImageurl] = useState("");
  const [selectedPower, setSelectedPower] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const [PowerListing, setPowerListing] = useState([]);
  const [Vehiclesnames, setVehiclesnames] = useState([]);
  const [showAdditionalInputs, setShowAdditionalInputs] = useState(false);
  const [selectedOcppConnector, setSelectedOcppConnector] = useState("0");
  const [CategoryEditData, setCategoryEditData] = useState({});
  const [CorporateData, setCorporateData] = useState([]);
  const [selectedCorporate, setSelectedCorporate] = useState('');
  const [loadings, setLoadings] = useState(false);
  const [Description, setDescription] =  useState("");

   
  
  
    const handlecorporateChange = (selectedOption) => {
      console.log("selectedOption3wrewgfreh", selectedOption);
      if(selectedOption) {
     setSelectedCorporate( selectedOption._id );
      } else {
        setSelectedCorporate(null);
      }
    }
  
    const fetchCorporate = async () => {
      setLoadings(true);
      
      // Base API URL
      let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/corporate`);
     
      
   try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
          },
        });
    
        console.log("response", response);
    
        setCorporateData(response.data?.data);
      // Assuming API returns totalCount for pagination
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoadings(false);
      }
    };
    
    // Re-fetch users whenever searchTerm changes
    useEffect(() => {
      if (Role === "false") {
        fetchCorporate();  // Only fetch corporate data if Role === "false"
      }
    }, [Role]);
    const corporateOptions = CorporateData?.map(corporate => ({
      value: corporate._id,
      label: `${corporate.corporate_name} (${corporate?.email})`,
      _id: corporate._id,
    }));


  const fetchData = async () => {
    const apiEndpoint = `${GpsBaseURL}/master/edit/${CategoryID}`;
    
    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
          
        }
      });
  console.log("wholeeData", res);
      if (res  && res.data.data) {
        setCategoryEditData(res.data.data); // Set the first item in the data array
      } else {
        console.error("No charger data found");
      }
    } catch (error) {
      console.error("Error fetching charger data:", error);
    }
  }
  

  useEffect(() => {
    fetchData();
  }, []);
  // console.log("chargerData", charger);



  const handleAdditionalInput = (e) => {
    setSelectedOcppConnector(e.target.value.replace(/\D/, "")); // Ensure only integers are entered
  };

  const handlePowerInput=(e)=> {
    setSelectedPower([e.target.value]);
    };
    
    const handleVehicleInput=(e)=> {
      setSelectedVehicle(e.target.value);
      };

 



  // New state for the additional input field
 

;



  



  useEffect(() => {
   
    setImageurl(FilterCategoryEditData?.master_image || null);
      
    },
   [FilterCategoryEditData]);
  

  const handleTitleName = (e) => {
    setTitleName(e.target.value);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  }

  const handleStatusType = (e) => {
    setSelectedStatusType(e.target.value);
  };
  useEffect(() => {
    if (CategoryEditData) {
      setTitleName(CategoryEditData?.title || "");
      setDescription(CategoryEditData?.description);
      setSelectedStatusType(CategoryEditData.status || "");
      if(CategoryEditData?.corporate_id) {
        setSelectedCorporate(CategoryEditData?.corporate_id[0]);
      }
      

      // setSelectedFile(FilterCategoryEditData?.master_image || null);
      
    }
  }, [CategoryEditData]);
  
  const UpdateFilterCategory = async (FilterCategoryEditData) => {
  if (!selectedCorporate && Role === "false") {
                  Swal.close(); // Close the loader before showing the error message
                  Swal.fire({
                    icon: "error",
                    title: "Validation Error",
                    text: "Please select a Corporate before proceeding.",
                  });
                  return; // Stop further execution
                }
  
    console.log("Updating Filter Category with ID:", FilterCategoryEditData._id);
  
    // Create a new FormData object
    let formData = new FormData();
  
    // Append the form data fields
    formData.append("title", TitleName);
    // formData.append("status", selectedStatusType);
    if( selectedFile ) {
      formData.append("master_image", selectedFile);
    }
  if(selectedCorporate) {
            formData.append("corporate_id", selectedCorporate);
          }
  
    Swal.fire({
      title: 'Updating Category...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    // Make the API request
    let response = await request({
      url: `${GpsBaseURL}/master/${FilterCategoryEditData._id}`,
      method: "PUT",
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${uniqueToken}`,
      }
    });
  
    // Handle the response
    if (response.statusCode === 200) {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Filter Category Updated Successfully...",
        showConfirmButton: false,
        timer: 1500,
      });
      navigate(`/masters/categorylist`);
    } else {
      // Handle errors
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update Filter Category",
      });
    }
  };
  if( CategoryEditData?.corporate_id ) {
    console.log("inside",CategoryEditData?.corporate_id[0]);
  } else {
    console.log("ouside", CategoryEditData?.corporate_id);
  }
  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/masters/categorylist/edit/${CategoryID}`);
    }
    const handleDescriptionChange =  (e) =>  setDescription(e.target.value);

console.log("corporateID", selectedCorporate);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                     Category Edit
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2 d-flex justify-content-start align-items-center">
  <h5 className="caption-subject bold uppercase mx-3">
    <button className="btn btn-success" onClick={() => navigate(-1)}>
      Back
    </button>
  </h5>
  <h5 className="caption-subject bold uppercase mx-3">
    <button className="btn btn-success" onClick={handleReset}>
      Reset
    </button>
  </h5>
</div>

                </div>
                <div className="portlet-body mx-3">
                  <hr style={{ marginTop: "" }} />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Title
                            </label>
                            <div className="col-sm-6">
                              <input
                              value={TitleName}
                                onChange={handleTitleName}
                                className="form-control"
                                id="name_id"
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        {Role ==="false" && (
                          <>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="file"
                              className="col-sm-2 control-label"
                            >
                              Select Corporate
                            </label>
                            <div className="col-sm-6">
                            <Select
  options={corporateOptions}
  onChange={handlecorporateChange}
  value={selectedCorporate ? corporateOptions?.find(option => option.value === selectedCorporate) : null}
  placeholder="Select Corporate"
  isClearable
  styles={{
    control: (base) => ({
      ...base,
      height: '38px', 
      width: '100%',
      boxShadow: 'none',
      minWidth: '0',
      flex: 1,
    }),
  }}
/>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        </>
                        )}

<div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Description
                            </label>
                            <div className="col-sm-6">
                              <textarea
                              type="text"
                                onChange={handleDescriptionChange}
                                className="form-control"
                                id=""
                                name=""
                                value={Description}
                                autoComplete="off"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Image
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="file"
                                onChange={handleFileChange}
                          
                                className="form-control"
                                id="file"
                                name="file"
                              />
                            </div>
                            <div className="col-sm-4 control-label">
            {/* Show image preview if an existing image URL is available */}
            {Imageurl && typeof Imageurl === 'string' && (
              <img
                src={Imageurl} // Use the image URL for src
                alt="Current Category"
                style={{ width: '100px', height: '100px', objectFit: 'cover', marginLeft: "180px" }}
              />
            )}

          
          </div>
                          </div>
                        </div>


                        {/* <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="statusType"
                              className="col-sm-2 control-label"
                            >
                              Status
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleStatusType}
                                value={selectedStatusType}
                                type="text"
                                className="form-control"
                                id="statusType"
                                name="statusType"
                              >
                                <option value="0">Select Status</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div> */}
                        <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={() => UpdateFilterCategory(FilterCategoryEditData)}
                              //ssssonClick={UpdateFilterCategory(FilterCategoryEditData)}
                              value="Update Category"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Edit;
